import { cn } from '@/lib/utils';
import type { VehicleFromIndexer } from '@/models/types';
import { Button } from '../../ui/button';
import { CHARGING_PLUG_OPTIONS_MAP } from './charger-type-selector';

export const VehicleChargingPlugBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  buttonVariant = 'ghost',
}: {
  value: VehicleFromIndexer['charging_plug'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  buttonVariant?: 'outline' | 'ghost';
}) => {
  const option = CHARGING_PLUG_OPTIONS_MAP.find(
    (option) => option.value === value,
  );

  return (
    <Button
      variant={buttonVariant}
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {option?.icon}
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {
            CHARGING_PLUG_OPTIONS_MAP.find((option) => option.value === value)
              ?.label
          }
        </p>
      )}
    </Button>
  );
};
